import { render, staticRenderFns } from "./DownloadAppPage.vue?vue&type=template&id=2d64a182&scoped=true&"
import script from "./DownloadAppPage.vue?vue&type=script&lang=js&"
export * from "./DownloadAppPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAppPage.vue?vue&type=style&index=0&id=2d64a182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64a182",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d64a182')) {
      api.createRecord('2d64a182', component.options)
    } else {
      api.reload('2d64a182', component.options)
    }
    module.hot.accept("./DownloadAppPage.vue?vue&type=template&id=2d64a182&scoped=true&", function () {
      api.rerender('2d64a182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/DownloadAppPage.vue"
export default component.exports